import request from '../api';

// 查询节目列表
export function getAppLiveProgramPage(data) {
  return request.post('/app/liveProgram/getAppLiveProgramPage', data);
}

// 直播间列表
export function getAppLiveRoomPage(data) {
  return request.post(`/app/liveRoom/getAppLiveRoomPage`, data);
}

// 我的直播间列表
export function getAppMyLiveRoomPage(data) {
  return request.post(`/app/liveRoom/getAppMyLiveRoomPage`, data);
}

// 修改直播间
export function updateLiveRoom(data) {
  return request.post(`/app/liveRoom/updateLiveRoom`, data);
}

// 根据直播间ID获取节目列表
export function getAppLiveRoomProgramList(roomId) {
  return request.post(`/app/liveRoom/getAppLiveRoom/${roomId}`, {});
}

// 获取App直播间详情
export function getAppLiveRoom(id) {
  return request.post(`/app/liveRoom/getAppLiveRoom/${id}`, {});
}

// 删除直播间
export function deleteLiveRoom(id) {
  return request.post(`/app/liveRoom/deleteLiveRoom/${id}`, {});
}

// 添加直播间
export function addLiveRoom(data) {
  return request.post(`/app/liveRoom/addLiveRoom`, data);
}

// 开始直播
export function startLive(roomId) {
  return request.post(`/app/liveRoom/startLive/${roomId}`, {});
}

// 结束直播
export function stopLive(roomId) {
  return request.post(`/app/liveRoom/stopLive/${roomId}`, {});
}

// 查询直播间状态
export function getLiveRoomStatSession(roomId) {
  return request.post(`/app/virtualManApi/liveSession/statSession`, { roomId });
}

// 获取直播的权益
export function getLiveBenefit() {
  return request.post('/app/liveRoom/getLiveBenefit');
}
// 根据类型获取App用户资源详情
export function appUserResourceByType(data) {
  return request.post('/app/userResource/appUserResourceByType', data);
}

// 直播支付
export function payLive(data) {
  return request.post('/app/liveRoom/payLive', data);
}

// md内容
export function liveRoomTextRoom(roomId) {
  return request.get(`/app/liveRoom/text/callback/${roomId}`);
}

// 直播流状态
export const LIVE_STREAM_STATUS_CODES = {
  CLOSED: 0, // 已停止
  WAITING_START: 1, // 待启动
  WAITING_SESSION_START: 2, // 待启动会话
  STARTING: 3, // 启动中
  STARTED: 4, // 已启动
  CLOSING: 5, // 关闭中
  WAITING_CLOSE: 6, // 待关闭
};

// 直播流状态的描述性文本
export const LIVE_STREAM_STATUS_TEXTS = {
  [LIVE_STREAM_STATUS_CODES.CLOSED]: '已停止',
  [LIVE_STREAM_STATUS_CODES.WAITING_START]: '待启动',
  [LIVE_STREAM_STATUS_CODES.WAITING_SESSION_START]: '待启动会话',
  [LIVE_STREAM_STATUS_CODES.STARTING]: '启动中',
  [LIVE_STREAM_STATUS_CODES.STARTED]: '已启动',
  [LIVE_STREAM_STATUS_CODES.CLOSING]: '关闭中',
  [LIVE_STREAM_STATUS_CODES.WAITING_CLOSE]: '待关闭',
};
